import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/tire-patch-components'
import { theme } from '../../../styles/_variables'
import { STATUS, STATUSTEXTSELECTOR, STATUSCOLORSELECTOR } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>เลขที่</HeaderLabel>,
    accessor: 'refId',
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.refId, filter.value),
    sortable: false,
    filterable: true,
    width: 150,
  }, {
    Header: () => <HeaderLabel>วันที่แจ้ง</HeaderLabel>,
    accessor: 'patchDate',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 130,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>เบอร์ยาง</HeaderLabel>,
    accessor: 'Serial.serialNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
  //   Header: () => <HeaderLabel>ชื่อ</HeaderLabel>,
  //   accessor: 'Serial.inventoryOption.variantName',
  //   sortable: false,
  //   filterable: false,
  //   Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
  //   Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  //   filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
  //   width: 250,
  //   margin: '0 50px',
  // }, {
    Header: () => <HeaderLabel>ชื่อผู้แจ้งซ่อม</HeaderLabel>,
    accessor: 'Driver.fullname',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 200,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>สถานที่</HeaderLabel>,
    accessor: 'TirePatchStore.name',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 200,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ชื่อผู้บันทึก</HeaderLabel>,
    accessor: 'CreatedBy',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={`${props.value.firstname} ${props.value.lastname}`}><CellText>{props.value.firstname} {props.value.lastname}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 200,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={STATUSCOLORSELECTOR(props.value)} bold>{STATUSTEXTSELECTOR(props.value)}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
    key='filter'
    data={STATUS}
    handleChange={e => onChange(e)}
    filter={true}
    statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
